import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-member-wrapper',
  templateUrl: './member-wrapper.component.html',
  styleUrls: ['./member-wrapper.component.css']
})
export class MemberWrapperComponent implements OnInit {
  @Input() memberId?: string;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();


  constructor() { }

  ngOnInit() {
  }

  onSaveMember(evt:any) {
    this.onSave.emit(evt);
  }

  closeModal(event?:any) {
    this.onCloseModal.emit(event);
  }
}
